
if (!customElements.get('video-with-text-plyr')) {
  class VideoWithTextPlyr extends HTMLElement {
    cancelPlay = false;

    constructor() {
      super();
      this.section = this.closest('video-with-text');
      this.videoWrapper = this.querySelector('.video-with-text__player-wrapper');
      this.videoElement = this.querySelector('[data-plyr-video]');
      this.autoplay = this.section?.getAttribute('data-autoplay') == 'true';
      this.videoCount = Number(this.section?.getAttribute('data-video-count'));

      this.initVideo();
    }

    initVideo() {
      const plyrElemnt = this.querySelector('[data-plyr-video]');
      // 懒初始化 video
      const player = new Plyr(plyrElemnt, {
        autoplay: false,
        resetOnEnd: false,
        muted: true,
        controls: [
          'play-large', // The large play button in the center
          // 'restart', // Restart playback
          // 'rewind', // Rewind by the seek time (default 10 seconds)
          'play', // Play/pause playback
          // 'fast-forward', // Fast forward by the seek time (default 10 seconds)
          'progress', // The progress bar and scrubber for playback and buffering
          'current-time', // The current time of playback
          'duration', // The full duration of the media
          'mute', // Toggle mute
          'volume', // Volume control
          // 'captions', // Toggle captions
          // 'settings', // Settings menu
          // 'pip', // Picture-in-picture (currently Safari only)
          // 'airplay', // Airplay (currently Safari only)
          // 'download', // Show a download button with a link to either the current source or a custom URL you specify in your options
          'fullscreen', // Toggle fullscreen
        ],
        tooltips: {
          controls: false,
          seek: false,
        },
        youtube: {
          modestbranding: 1,
          title: false,
          mute: true,
          showinfo: 1,
          rel: 0,
        },
        //ratio: '16:9',
        quality: { default: 1080, options: [4320, 2880, 2160, 1440, 1080, 720] },
      });
      player.on('ended', () => {
        this.onPlayingEnd(player);
      });
      this.player = player;
    }

    play() {
      this.cancelPlay = false;
      if (this.player) {
        this.player.play();
      } else {
        this.initVideo();
        this.player.on('ready', () => {
          if (!this.cancelPlay) {
            this.player.play();
          }
        });
      }
    }

    pause() {
      this.cancelPlay = true;
      if (this.player) {
        this.player.pause();
      }
      // else {
      //   this.initVideo();
      //   this.player.on('ready', () => {
      //     if (this.cancelPlay) {
      //       this.player.pause();
      //     }
      //   });
      // }
    }

    stop() {
      this.cancelPlay = true;
      if (this.player) {
        this.player.stop();
      }
    }

    onPlayingEnd(player) {
      if (this.videoCount > 1) {
        if (player.currentTime != player.duration) {
          player.pause();
        }
        this.section.mySwiper?.slideNext();
      }
    }

  }
  customElements.define('video-with-text-plyr', VideoWithTextPlyr);
}


if (!customElements.get('video-with-text')) {
  class VideoWithText extends HTMLElement {
    firstIntoView = true; // 首次进入视口
    playList = [];

    constructor() {
      super();
      this.videoWrapper = this.querySelector('.video-with-text__player-wrapper');
      this.videoElement = this.querySelector('[data-plyr-video]');
      this.autoplay = this.getAttribute('data-autoplay') == 'true';
      this.videoCount = Number(this.getAttribute('data-video-count'));

      if (this.videoCount > 1) {
        this.initSwiper();
      }

      if (this.autoplay) {
        window.addEventListener('scroll', this.onScroll.bind(this));
      }
    }

    onScroll() {
      if (this.firstIntoView) {
        const scrollBottom = window.scrollY + window.innerHeight;
        let playerComponent;
        if (this.videoCount > 1) {
          playerComponent = this.mySwiper.slides[this.mySwiper.activeIndex].querySelector('video-with-text-plyr');
        } else {
          playerComponent = this.querySelector('video-with-text-plyr');
        }
        if (scrollBottom > this.videoWrapper.offsetTop && playerComponent.player?.paused) {
          playerComponent.play();
          this.firstIntoView = false;
          this.removeEventListener('scroll', this.onScroll.bind(this));
        }
      }
    }

    initSwiper() {
      this.mySwiper = new Swiper(this.querySelector(`.swiper`), {
        loop: true,
        allowTouchMove: false,
        slidesPerView: 1,
        observer: true,
        resizeObserver: true,
        observeParents: true,
        breakpoints: {},
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          clickable: true,
        },
        on: {
          slideChangeTransitionEnd: swiper => {
            if (!swiper.swiperInited) return;
            // Fix js event of copied slide.
            swiper.slideToLoop(swiper.realIndex, 0, true);
          },
          slideChange: swiper => {
            if (!swiper.swiperInited) {
              swiper.swiperInited = true;
              return;
            }
            const currentSlide = swiper.slides[swiper.activeIndex];
            setTimeout(() => {
              currentSlide.querySelector('video-with-text-plyr')?.play();
            }, 1);
            for (const slide of swiper.slides) {
              if (slide != currentSlide) {
                setTimeout(() => {
                  slide.querySelector('video-with-text-plyr')?.stop();
                }, 1);
              }
            }
          },
        },
      });
    }
  }
  customElements.define('video-with-text', VideoWithText);
}
